export enum LoaderActionTypes {
  CHANGE_LOADER_STATUS = 'CHANGE_LOADER_STATUS',
}
